  <template>
  <v-navigation-drawer
    v-model="drawer"
    right
    app
    temporary
    floating
    :width="400">
    <v-toolbar color="white" flat dense>
      <v-layout justify-center align-center mt-4>
        <v-flex xs1 mt-4>
          <v-btn fab bot small class="k-orange-linear-text" icon flat @click="closeDrawer()">
            <v-icon small>fas fa-angle-right</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs11 class="text-xs-center">
          <div class="f1-5em text-xs-center k-orange-linear-text">
            <slot name="title"></slot>
          </div>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <component :is="content" :edit="edit" :url="url"></component>
  </v-navigation-drawer>
</template>

<script>
import EventBus from '@/event-bus';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    fields: {
      type: String,
      required: false,
    },
    content: {
      type: String,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    bus: {
      type: Object,
      default() {
        return {
          sidebarFormError: 'sidebarFormError',
          openRightDrawer: 'openRightDrawer',
          rightDrawerSaved: 'rightDrawerSaved',
          closeRightDrawer: 'closeRightDrawer',
        };
      },
    },
  },
  mounted() {
    EventBus.$on(this.bus.openRightDrawer, () => {
      this.drawer = true;
    });
    EventBus.$on(this.bus.closeRightDrawer, () => {
      this.drawer = false;
    });
  },
  beforeDestroy() {
    EventBus.$off(this.bus.openRightDrawer);
    EventBus.$off(this.bus.closeRightDrawer);
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    closeDrawer() {
      EventBus.$emit(this.bus.closeRightDrawer);
    },
  },
};
</script>

<style scoped>
aside.navigation-drawer {
  z-index: 205;
}
</style>



// WEBPACK FOOTER //
// src/components/global/RightDrawer.vue